import ReactDOM from "react-dom";
import type { ReactNode, ReactPortal } from "react";

interface PortalProps {
    children: ReactNode;
    containerId: string;
}

export const Portal = ({ children, containerId }: PortalProps): ReactPortal | null => {
    const container = document.getElementById(containerId);
    if (!container) return null;
    return ReactDOM.createPortal(children, container);
};
